import React from 'react';
import SplitSection from '../common/split-section';
import ProductsGrid from './products-grid';
import { ProductsForEveryoneProps } from '../types';

const ProductsForEveryoneSection: React.FC<ProductsForEveryoneProps> = ({
  products,
}) => {
  return (
    <section className="flex flex-wrap mt-6 py-8 wg-container">
      <SplitSection
        heading="Products for everyone"
        description="Built for scale, made by experts and secure by design. Bringing you maximum tax savings, unmatched speed and complete peace of mind."
        headingClasses="flex flex-col pl-12 justify-center w-full mt-16 xl:items-center xl:mt-0 xl:w-1/3 lg:w-1/3 sm:mt-0 sm:pl-0 text-left mx-0 max-w-none"
        classname="sm:flex-col md:flex-col-reverse flex-row-reverse"
        child={<ProductsGrid products={products} />}
      />
    </section>
  );
};

export default ProductsForEveryoneSection;
